import * as React from 'react';
import Box from '@mui/material/Box';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormHelperText from '@mui/material/FormHelperText';

interface BasicDatePickerProps {
  label?: string;
  name?: string;
  value: any;
  onChange: (date: any) => void;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  sx?: any;
  margin?: 'none' | 'normal' | 'dense';
}

export default function BasicDatePicker({
  label,
  name,
  value,
  onChange,
  error,
  helperText,
  required,
  disabled,
  sx,
  margin = 'normal'
}: BasicDatePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ width: '100%', minWidth: 0 }}>
        <DemoContainer
          components={['DatePicker']}
          sx={{ overflow: 'visible', width: '100%', pt: 0 }}
        >
          <DatePicker
            label={label}
            value={value}
            onChange={onChange}
            disabled={disabled}
            slotProps={{
              textField: {
                error,
                required,
                margin,
                name,
                disabled,
                fullWidth: true,
              }
            }}
            sx={{
              width: '100%',
              '& .MuiInputBase-root': {
                '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'error.main',
                }
              },
              ...sx
            }}
          />
        </DemoContainer>
        {helperText ? (
          <FormHelperText error={error} sx={{ mx: '14px', mt: 0.25 }}>
            {helperText}
          </FormHelperText>
        ) : null}
      </Box>
    </LocalizationProvider>
  );
}